import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { AppShell } from '@/host/AppShell';
import { ACCOUNT_DISABLED } from '@/platform/auth/auth-error-search';
import { isAccountDisabled, sessionQuery } from '@/platform/auth/useAuth';

export const Route = createFileRoute('/_app')({
   // Resolved before anything below renders or loads: signed out never sees the shell.
   beforeLoad: async ({ context }) => {
      const user = await context.queryClient.query(sessionQuery).catch((error: unknown) => {
         if (isAccountDisabled(error)) throw redirect({ to: ROUTES.LOGIN, search: { error: ACCOUNT_DISABLED }, replace: true });
         throw error;
      });
      if (!user) throw redirect({ to: ROUTES.LOGIN, replace: true });
      // Required MFA without TOTP: enrol on the sign-in page only (not profile).
      if (!user.compliant) throw redirect({ to: ROUTES.LOGIN, replace: true });
      return { user };
   },
   component: AppShell
});
